import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=5cfee2a5&scoped=true"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=5cfee2a5&prod&lang=scss&scoped=true"
import style1 from "./HorizontalMenu.vue?vue&type=style&index=1&id=5cfee2a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfee2a5",
  null
  
)

export default component.exports